import styled from "styled-components"
import { colors } from "../../Utils/color"
import { Link } from "react-router-dom"

const FooterDiv = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 80px;
    background-color: ${colors.secondary};
    border-top: 5px solid ${colors.primary};
    @media screen and (max-width: 744px) {
        flex-direction: column;
        gap: 10px;
        padding: 15px 0;
    }

    > div {
        display: flex;
        align-items: center;
        gap: 30px;
    }

    > p {
        font-size: 1.1em;
        font-weight: 500;
        margin: 0;
        @media screen and (max-width: 744px) {
            font-size: 1.05em;
        }
    }
`
const FooterMediasLink = styled(Link)`
    color: ${colors.textColor};
    font-size: 1.7em;
    @media screen and (max-width: 744px) {
        font-size: 1.4em;
    }

    &:hover {
        color: ${colors.primary};
    }
`

function Footer() {
    return (
        <FooterDiv>
            <div>
                <FooterMediasLink to={"/"}>
                    <i class="fa-brands fa-x-twitter"></i>
                </FooterMediasLink>
                <FooterMediasLink to={"/"}>
                    <i class="fa-brands fa-telegram"></i>
                </FooterMediasLink>
                {/*<FooterMediasLink>
                    <i class="fa-brands fa-discord"></i>
                </FooterMediasLink>*/}
            </div>

            <p>© 2025 StreamFlixFr - Aucun droits réservés.</p>
        </FooterDiv>
    )
}

export default Footer
